import Swiper, {Keyboard, Navigation, Scrollbar} from 'swiper';
Swiper.use([Keyboard, Navigation, Scrollbar]);

export default class EventCarousel {
	constructor(elm) {
		this.elm = elm;

        this.swiperContainer = this.elm.querySelector('[data-swiper-container]');
        this.prev = this.elm.querySelector('[data-swiper-prev]');
		this.next = this.elm.querySelector('[data-swiper-next]');

		this.prevArea = this.elm.querySelector('[data-swiper-prev-area]');
		this.nextArea = this.elm.querySelector('[data-swiper-next-area]');


		this.numberOfSlides = this.swiperContainer.querySelectorAll('.swiper-slide').length;

        this.breakpoint = window.matchMedia('(min-width:992px)');

		this.boundHandleBreakpoint = this.handleBreakpoint.bind(this);
        this.breakpoint.addEventListener('change', this.boundHandleBreakpoint);
        this.handleBreakpoint();

		if (this.prevArea) {
			this.prevArea.addEventListener('click', e => {
				this.swiper.slidePrev();
			});
		}
		if (this.nextArea) {
			this.nextArea.addEventListener('click', e => {
				this.swiper.slideNext();
			});
		}

		this.scrollbar = this.elm.querySelector('[data-swiper-scrollbar]');

	}

	init() {

		this.swiper = new Swiper(this.swiperContainer, {
			init: false,
			threshold: 2,
			slideClass: 'swiper-slide',
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
            navigation: {
				prevEl: this.prev,
				nextEl: this.next,
			},
            scrollbar: {
                el: this.scrollbar,
                draggable: false,
            },
			slidesPerView: 1,
			spaceBetween: 10,
			grabCursor: true,
			touchEventsTarget: 'container',
			speed: 600,
            watchSlidesProgress: true,
			breakpoints: {
				992: {
					slidesPerView: 3,
                    spaceBetween: 24
				},
			},
		});

		this.swiper.on('resize', (e) => {
			this.swiper.update();
		});

		this.prevArea.classList.add('swiper-button-disabled');
		this.swiper.on('slideChange', (e) => {
			if(this.swiper.isBeginning) {
				this.prevArea.classList.add('swiper-button-disabled');
			} else {
				this.prevArea.classList.remove('swiper-button-disabled');
			}
			if(this.swiper.isEnd) {
				this.nextArea.classList.add('swiper-button-disabled');
			} else {
				this.nextArea.classList.remove('swiper-button-disabled');
			}
		});

		this.swiper.init();
	}

    handleBreakpoint() {
        if(this.breakpoint.matches) {
			if(this.numberOfSlides > 3) {
				this.init();
			} else {
				this.destroy();
			}
        } else {
			if(this.numberOfSlides > 1) {
				this.init();
			} else {
				this.destroy();
			}
        }
    }

    destroy() {
        this.breakpoint.removeEventListener('change', this.boundHandleBreakpoint);
	}
}
